import React, { useState, useEffect } from "react";
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import { makeStyles, Box, TextField, Button, CircularProgress, Collapse } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import DeleteIcon from '../assets/icons/primary-blue-bin.png';
import { PrimaryButton } from '../common/button';
import colors from '../CustomizedUIs/Colors'
import DevicesList from './DeviceList';

const useStyles = makeStyles(theme => ({
    btnMetaData: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
    },
    textMetaData: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: 8
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#88898c',
        paddingLeft: '16px'
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: 'normal',
        paddingLeft: '16px'
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingLeft: '16px'

    },
}));

const MetaData = ({ value, textOnChange, validate, onRemove }) => {
    const classes = useStyles();
    const translate = useTranslate();

    return (
        <Box display='flex' justifyContent='center' width={600} mt={1}>

            <Box display='flex' borderRadius={4} bgcolor='background.paper' px={1}>
                <TextField
                    required
                    variant='filled'
                    label={translate(`pos.user.email`)}
                    error={validate.value.isError && validate.value.message != ""}
                    helperText={validate.value.isError ? validate.value.message : ""}
                    value={value}
                    onBlur={textOnChange('value')}
                    onChange={textOnChange('value')}
                    size="small"
                    style={{ width: '400px' }}
                    FormHelperTextProps={{
                        className: classes.textError
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.textLabel,
                            error: classes.textLableError
                        }
                    }}
                    InputProps={{
                        className: classes.input,
                        classes: {
                            underline: validate.value.isError ? classes.underlineError : (validate.value.message !== "" ? classes.underline : classes.underlineNotValue),
                            focused: classes.focuses
                        }
                    }}
                />
            </Box>
            <IconRadiusButton
                style={{ marginLeft: 8 }}
                onClick={onRemove}
            >
                <img src={DeleteIcon} width='18px' height='18px'></img>
            </IconRadiusButton>
        </Box>
    )
}

const Index = () => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(false);
    const [listEmail, setListEmail] = useState([]);
    const [validateEmails, setValidateEmails] = useState([]);
    const [isSave, setIsSave] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);

    const onChangeEmail = index => prop => (e) => {
        var tempArray = listEmail.slice()
        tempArray[index][prop] = e.target.value
        setListEmail(tempArray)
        validateEmail(index)(e.target.value)(prop)
    }

    const validateEmail = index => value => prop => {
        var validates = validateEmails.slice()
        if (value === "") {
            validates[index][prop].isError = true
            validates[index][prop].message = "required"
        }
        else {
            if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value) === false) {
                validates[index][prop].isError = true
                validates[index][prop].message = translate(`pos.auth.errorEmail`)
            }
            else {
                validates[index][prop].isError = false
                validates[index][prop].message = ""
            }
        }
        setValidateEmails(validates)
    }

    const onClickAddEmail = () => {
        if (listEmail.length < 5) {
            var tempArray = listEmail.slice()
            var validates = validateEmails.slice()
            tempArray.push({
                value: "",
            })
            validates.push({
                value: { isError: true, message: "" }
            })
            setValidateEmails(validates)
            setListEmail(tempArray)
        }
    }

    const onRemoveEmail = index => () => {
        if (listEmail.length > 1) {
            var tempArray = listEmail.slice()
            tempArray.splice(index, 1)
            var validates = validateEmails.slice()
            validates.splice(index, 1)
            setValidateEmails(validates)
            setListEmail(tempArray)
        }
    }

    const getListEmail = () => {
        setLoading(true)
        dataProvider('GET_LIST', "support/list", {
            filter: {},
            sort: {},
            pagination: {}
        }).then(({ data }) => {
            data.map(user => {
                listEmail.push({ value: user.email })
            })
            var validateEmails = []
            listEmail.forEach(value => {
                validateEmails.push({
                    name: {
                        isError: 'false',
                        message: ''
                    },
                    value: {
                        isError: 'false',
                        message: ''
                    }
                })
            })
            setValidateEmails(validateEmails)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        });
    }

    const handleOnSave = () => {
        setLoading(true)
        dataProvider('CREATE', 'support/create', {
            data: { listEmail }
        }).then(({ data }) => {
            setIsSave(true)
            setOpenAlert(false)
            setLoading(false)
        }).catch(response => {
            setIsSave(false)
            setOpenAlert(true)
            setLoading(false)
            // TODO: Should show error message
        });
    }

    const disableSaveButton = () => {
        if (listEmail.length === 0) return true;
        for (let i = 0; i < validateEmails.length; i++) {
            if (validateEmails[i].value.isError === true) {
                return true
            }
        }
        return false;
    }

    useEffect(() => {
        getListEmail()
    }, []);

    if (loading) return <Loading />
    return (
        // <DevicesList
        // // readOnly={!permissions.functionAction.find(value => value.function === 'Unit' && value.isUpdate)}
        // >
        // </DevicesList>
        <Box>
            <Box mt={3}>
                <Collapse in={openAlert}>
                    <Alert severity={isSave ? "success" : "error"}>{translate(`pos.auth.sendMailError`)}</Alert>
                </Collapse>
            </Box>
            <Box display="flex" padding='60px' justifyContent='center'>
                <Box>
                    <Box my={1} mt={2}>
                        <PrimaryButton
                            secondary
                            style={{ width: 200 }}
                            label={translate(`pos.support.email`)}
                            onClick={onClickAddEmail}
                        />
                    </Box>
                </Box>
                <Box>
                    {
                        listEmail.map((row, index) => (
                            <MetaData
                                key={index}
                                value={row.value}
                                validate={validateEmails[index]}
                                textOnChange={onChangeEmail(index)}
                                onRemove={onRemoveEmail(index)}
                            />
                        ))
                    }
                    <Box width='100%' display='flex' justifyContent='flex-end' mt={1}>
                        <Button
                            disabled={disableSaveButton()}
                            style={{ maxWidth: 40, marginRight: 120 }}
                            onClick={handleOnSave}
                            variant="contained" color='primary' size='large'>
                            {loading ? (
                                <CircularProgress
                                    size={20}
                                    thickness={2}
                                    color='inherit'
                                />
                            ) : translate('resources.room.save')}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
};

export default Index;
